"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rfid_log_types_1 = require("./rfid-log.types");
const adjustment_1 = require("services/adjustment");
const moment_1 = __importDefault(require("moment"));
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridRfidLog)(dataStates);
    if (response.isError) {
        dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            countData: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { scan_date: new Date(item.scan_date) });
            })
        };
        dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_DATA_GRID, payload });
    }
});
const getDataGridExcelExport = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridRfidLog)(dataStates);
    if (response.isError) {
        dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            countData: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { scan_date: (0, moment_1.default)(item.scan_date).format('DD-MM-YYYY HH:mm') });
            })
        };
        dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_DATA_GRID_EXPORT_EXCEL, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.ON_PAGE_CHANGE, payload: { dataStates } });
});
const onSortChange = payload => dispatch => {
    dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.ON_SORT_CHANGE, payload });
};
const onToggleError = payload => dispatch => {
    dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_ERROR, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.ON_FILTER_CHANGE, payload });
};
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.ON_MUTATION_CLICK, payload });
};
const onToggleLoading = (payload) => dispatch => {
    dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_LOADING, payload });
};
const getDataDropdownArea = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getDataDropdownArea)();
    if (response.isError) {
        dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            dataDropdownArea: response.data
        };
        dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_DATA_DROPDOWN_AREA, payload });
    }
});
const getDataDropdownPos = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getDataDropdownPos)(dataStates);
    if (response.isError) {
        dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            dataDropdownPos: response.data
        };
        dispatch({ type: rfid_log_types_1.adjustmentRfidLogTypes.SET_DATA_DROPDOWN_POS, payload });
    }
});
exports.default = {
    getDataGrid,
    onSortChange,
    onToggleError,
    onFilterChange,
    onClickMutation,
    onToggleLoading,
    onDataStateChange,
    getDataDropdownPos,
    getDataDropdownArea,
    getDataGridExcelExport
};
